import type { ReactNode } from "react";

import { cn } from "@/lib/utils";
import { getIcon } from "@/lib/icons";

type Tone = "emerald" | "blue" | "teal";

const tones: Record<Tone, string> = {
  emerald: "bg-primary/10 text-primary",
  blue: "bg-secondary/10 text-secondary",
  teal: "bg-accent/10 text-accent",
};

interface IconBadgeProps {
  icon: string;
  tone?: Tone;
  className?: string;
  size?: number;
  children?: ReactNode;
}

/** Rounded square containing a lucide icon, resolved from a string key. */
export function IconBadge({
  icon,
  tone = "teal",
  className,
  size = 22,
}: IconBadgeProps) {
  const Icon = getIcon(icon);
  return (
    <span
      className={cn(
        "inline-flex h-12 w-12 items-center justify-center rounded-xl",
        tones[tone],
        className,
      )}
      aria-hidden="true"
    >
      <Icon size={size} strokeWidth={2} />
    </span>
  );
}
